export default __webpack_public_path__ + "static/Szczucka-98a5be533b4c69957c9bcc6059f1af14.jpg";